// extracted by mini-css-extract-plugin
export default {"text":"UnlimitedDocumentsThanksModal__text--21N4b","image":"UnlimitedDocumentsThanksModal__image--zXVkw","content":"UnlimitedDocumentsThanksModal__content--3QEvf"};